import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DatabaseCacheService } from '../../../data/cache/database-cache.service';
import { CacheEvent } from '../../../data/cache/cache-event.model';

export interface UserSummarySnapshot {
  selectedSection: any;
  selectedUserWithUserData: any;
  attributes: any[];
  functions: string[];
  userDataList: any[] | null;
}

@Injectable({ providedIn: 'root' })
export class UserSummaryDataService {
  private readonly cache = inject(DatabaseCacheService);

  setUserContext(userId: string): void {
    void this.cache.setSelectedUserId(userId);
    this.cache.prepareUserDataList(userId, false);
  }

  getSnapshot(): UserSummarySnapshot {
    return {
      selectedSection: this.cache.getSelectedSection(),
      selectedUserWithUserData: this.cache.getSelectedUserWithUserData(),
      attributes: (this.cache.getSelectedSectionGroupUserDataAttributes() as any[]) ?? [],
      functions: (this.cache.getSelectedSectionGroupFunctions() as string[]) ?? [],
      userDataList: (this.cache.getUserDataList() as any[]) ?? null,
    };
  }

  get parametersUpdated$(): Observable<CacheEvent> {
    return this.cache.parametersUpdated;
  }
}
